import styled from 'styled-components';

export const BookedHtlInfoInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    border-bottom: 1px solid ${props.theme.colors.grey.lighte7};
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l18};
  `
);

export const BookedHtlInfoBlockWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      justify-content: space-between;
  `
);

export const BookedHtlInfoInnerBlk = styled.div(
  props => `
      width:70%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
  `
);

export const BookedHtlNameLocWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      flex-direction: column;
  `
);

export const BookedHtlNameText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font22};
      color: ${props.theme.colors.black.base};
      font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const BookedHtlLocText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.base};

      span{
          color: ${props.theme.colors.black.base};
          font-weight: ${props.theme.font.fontWeight.bold};
      }
      .greenText{
          color: ${props.theme.colors.green.base};
      }
  `
);

export const BookedHtlStayInfoWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
  `
);

export const BookedHtlDateWrap = styled.span(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.black.base};
      display: flex;
      align-items: center;
      padding-bottom: ${props.theme.spacing.small.s5};

      span{
          font-size: ${props.theme.font.small.font10};
          color: ${props.theme.colors.grey.base};
          padding-left: ${props.theme.spacing.base};
          padding-right: ${props.theme.spacing.base};
      }
  `
);

export const BoldText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      font-weight: ${props.theme.font.fontWeight.bold};
      padding-right: ${props.theme.spacing.small.s5};
  `
);

export const BookedHtlPaxInfo = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.black.base};
  `
);

export const BookedHtlImgBlk = styled.div(
  props => `
      widht:30%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
  `
);

export const BookedHtlImg = styled.img(
  props => `
      width: 10.6rem;
      height: 10.6rem;
      margin-left: ${props.theme.spacing.base};
  `
);
